export default __webpack_public_path__ + "static/media/24.05e60d90.jpg";